export default __webpack_public_path__ + "static/media/RTL.565b6a12.png";